import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClerkProvider } from "@clerk/react";
import { dark } from "@clerk/ui/themes";

const appearance = {
  theme: dark,
  captcha: { theme: "dark" },
  layout: { socialButtonsPlacement: "top", socialButtonsVariant: "blockButton" },
  elements: {
    socialButtonsBlockButton: { backgroundColor: "#FF2D75", color: "#FFFFFF", border: "none", minHeight: "48px", fontWeight: 600, fontSize: "15px" },
    socialButtonsBlockButtonText: { color: "#FFFFFF", fontWeight: 600 },
    socialButtonsProviderIcon: { backgroundColor: "#FFFFFF", borderRadius: "9999px", padding: "3px", width: "22px", height: "22px" },
    formButtonPrimary: { backgroundColor: "transparent", border: "1px solid #3A4270", color: "#F4F6FF", boxShadow: "none" },
    dividerText: { color: "#9AA3C7" },
  },
  variables: { colorPrimary: "#FF2D75", colorBackground: "#0E1430", colorForeground: "#F4F6FF", colorInput: "#151C3D", colorInputForeground: "#F4F6FF", fontFamily: "Poppins, sans-serif", borderRadius: "10px" },
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ClerkAuthProvider({ children }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async (attempt = 0) => {
      try {
        const cfg = await (await fetch(`${BACKEND_URL}/api/clerk/config`)).json();
        if (cfg.enabled) return cancelled || setConfig(cfg);
      } catch {}
      if (cancelled) return;
      if (attempt >= 20) return setUnavailable(true);
      setTimeout(() => load(attempt + 1), 1500);
    };
    load();
    return () => { cancelled = true; };
  }, []);

  if (unavailable) return <p style={{ padding: 24 }}>Sign-in is unavailable right now. Refresh the page to try again.</p>;
  if (!config) return null;
  return (
    <ClerkProvider
      publishableKey={config.publishable_key}
      proxyUrl={config.proxy_url || undefined}
      appearance={appearance}
      routerPush={(to) => navigate(to)}
      routerReplace={(to) => navigate(to, { replace: true })}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      afterSignOutUrl="/"
    >
      {children}
    </ClerkProvider>
  );
}
